import { FC } from "react";

import MuiInput from "@mui/material/TextField";
import InputLabel from "./InputLabel";

interface IInputProps {
  name: string;
  id: string;
  value?: string | boolean;
  placeholder?: string;
  type?: string;
  defaultValue?: any;
  label: string;
  required?: boolean;
  error?: any;
  variant?: any;
  disabled?: boolean;
  multiline?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input: FC<IInputProps> = ({
  name,
  id,
  value,
  onChange,
  type,
  placeholder,
  label,
  defaultValue,
  disabled,
  required,
  variant,
  error = null,
  multiline,
}) => {
  return (
    <>
      <InputLabel label={label} />
      <MuiInput
        name={name}
        id={id}
        value={value}
        required={required}
        onChange={onChange}
        defaultValue={defaultValue}
        fullWidth
        type={type}
        {...(error && { error: true, helperText: error })}
        variant="standard"
        placeholder={placeholder}
        multiline={multiline}
      />
    </>
  );
};

export default Input;
